/**
 * External dependencies
 */
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';

/**
 * Builds a complete URL with query parameters
 * @param baseUrl - The base URL
 * @param params - The parameters object
 * @returns URL instance with query parameters
 */
export function buildUrl(baseUrl: string, params: Record<string, any>): URL {
  const url = new URL(baseUrl);

  if (isEmpty(params)) {
    return url;
  }

  forEach(params, (value, key) => {
    if (value === null || value === undefined) {
      url.searchParams.append(key, String(value));
    } else if (typeof value === 'object') {
      url.searchParams.append(key, JSON.stringify(value));
    } else {
      url.searchParams.append(key, String(value));
    }
  });

  return url;
}

export function stableStringify(
  obj: Record<string, any> | undefined | null,
): string | null {
  if (!obj) return null;
  const entries = Object.entries(obj).sort(([a], [b]) =>
    a < b ? -1 : a > b ? 1 : 0,
  );
  return JSON.stringify(Object.fromEntries(entries));
}
